<template>
  <div v-if="useLinker().showModal()" class="linker-wrapper">
    <div class="linker-wrapper-inner">
      <div class="sub-header-text text-center">
        <span v-if="!useLinker().isGenerated()"
          >Getting everything ready for you...</span
        ><span v-else>All set! Let's go!</span>
      </div>
      <base-spinner v-if="!useLinker().isGenerated()" large dark class="mt-2" />
      <template v-else
        ><base-button
          class="mt-1"
          set-width
          @click="
            goExternal(useLinker().getFinalLink());
            useLinker().hideLinker();
          "
          >Continue <base-icon icon="arrow-circle-right"
        /></base-button>
      </template>
    </div>
  </div>
</template>
<script setup>
const goExternal = (link) => {
  window.open(link);
};
</script>
